import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
// -------------- Import Discrepancies ---------------- /
import { api__getRecommendedPosts } from "@/apis/posts/recommendation";
import { CarCardPlaceHolderGrid } from "@componentsShared/placeholders/CarCardPlaceHolder";
import { trackEvents } from "@/common/events/events";
import { checkFeatureFlag } from "@/common/config/websiteConfig";
import { useLocation } from "react-router-dom";
import { isAutosOrYearsScreen } from "@/pages/search/searchHooks/filtersHelpers";
import useApi from "@hooks/useApi";

// ----------- Import Styles ----------/
import stl from "./UnbxdRecommendationCards.module.css";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import useIsMobile from "@hooks/useIsMobile";
import HorizontalCarCard from "@/components/sharedComponents/HorizontalCarCard/HorizontalCarCard";
import useKeyPressSwitch from "@hooks/useKeyPressSwitch";
import { useState } from "react";
import useCookieClient from "@hooks/useCookieClient";
import { useSearchResultsData } from "@/pages/search/searchHooks/useSearchAndFilters";
import { ModernCard } from "@/components/SearchComponent/ModernCard";

// -------------- Types ---------------- /

// -------------- Component ---------------- /
var UnbxdRecommendationCards = function UnbxdRecommendationCards(_ref) {
  var _ref$recommendations = _ref.recommendations,
    recommendations = _ref$recommendations === void 0 ? 20 : _ref$recommendations,
    _ref$referral_locatio = _ref.referral_location,
    referral_location = _ref$referral_locatio === void 0 ? "search_zero_results" : _ref$referral_locatio;
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient;
  var user_uuid = getCookieClient("UUID") || null;
  var _useSession = useSession(),
    userData = _useSession.user;
  var _useSearchResultsData = useSearchResultsData(),
    similarItems = _useSearchResultsData.similarItems;
  var location = useLocation();
  var isAutosOrYearsPage = isAutosOrYearsScreen(location);
  var shouldUseSimilarItems = isAutosOrYearsPage || !checkFeatureFlag("FF_RECOMMENDATION_ENABLED");
  var hasSimilar = similarItems && (similarItems === null || similarItems === void 0 ? void 0 : similarItems.length) > 0;
  var isMobile = useIsMobile();
  var _useState = useState(false),
    showOldCard = _useState[0],
    setShowOldCard = _useState[1];
  var handleKeyPressSwitch = function handleKeyPressSwitch() {
    setShowOldCard(!showOldCard);
  };
  useKeyPressSwitch(handleKeyPressSwitch);
  var _useApi = useApi([user_uuid, shouldUseSimilarItems, hasSimilar, similarItems], function () {
      if (shouldUseSimilarItems && hasSimilar) {
        return Promise.resolve(_toConsumableArray(similarItems));
      }
      if (!user_uuid) {
        return Promise.resolve([]);
      }
      return api__getRecommendedPosts(user_uuid, recommendations).then(function (data) {
        if (data) {
          return data;
        }
      });
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    recommendationPosts = _useApi2[2];
  if (error) {
    return /*#__PURE__*/React.createElement("div", null, "error fetching recommendation");
  }

  // Only fall back to similarItems when that IS the intended source. Otherwise
  // (recommendation API path) don't render leftover similarItems while the API
  // is still loading — that stale data flashes on screen and gets replaced when
  // the real recommendation lands. Keep the loader until real data arrives.
  var useSimilarSource = shouldUseSimilarItems && hasSimilar;
  var posts = useSimilarSource ? recommendationPosts || similarItems || [] : recommendationPosts || [];
  loading = loading && posts.length === 0;
  return /*#__PURE__*/React.createElement("section", {
    className: stl.cardsContainer
  }, loading ? /*#__PURE__*/React.createElement(CarCardPlaceHolderGrid, {
    length: 20,
    columnWidth: 275
  }) : /*#__PURE__*/React.createElement("ul", {
    className: stl.cardsWrapper
  }, posts.map(function (post, idx) {
    return /*#__PURE__*/React.createElement("li", {
      className: stl.card,
      key: post.id
    }, !checkFeatureFlag("FF_DISABLE_NEW_CAR_CARD") && !showOldCard && isMobile ? /*#__PURE__*/React.createElement(HorizontalCarCard, {
      post: post,
      rank: idx + 1,
      page: 1,
      referralLocation: "recommendation_filter",
      onClick: function onClick() {
        trackEvents("recommendation_car_clicked", {
          uuid: user_uuid || null,
          post_id: post.id,
          referral_location: referral_location
        });
      }
    }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModernCard, {
      post: post,
      rank: idx + 1,
      page: 1,
      referralLocation: "recommendation_filter",
      sectionType: "zero results",
      onClick: function onClick() {
        trackEvents("recommendation_car_clicked", {
          uuid: user_uuid || null,
          post_id: post.id,
          referral_location: referral_location
        });
      }
    })));
  })));
};
export default UnbxdRecommendationCards;